import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const PRODUCTCATEGORY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ProductCategory.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.ProductCategory.Code')
    .required()
    .maxLength(10)
    .build(),
  FieldBuilder
    .checkbox('isPulpable', 'Entity.ProductCategory.IsPulpable')
    .build(),
  FieldBuilder
    .checkbox('isReturnable', 'Entity.ProductCategory.IsReturnable')
    .build(),
  FieldBuilder
    .checkbox('isByProduct', 'Entity.ProductCategory.IsByProduct')
    .build(),
  FieldBuilder
    .checkbox('mustBeSentToSap', 'Entity.ProductCategory.MustBeSentToSAP')
    .build(),
];

export const PRODUCTCATEGORY_CONFIG = {
  entityName: 'ProductCategory',
  localizationKey: 'General::Entity.ProductCategory',
  fields: PRODUCTCATEGORY_FIELDS,
  permission: 'ControllingStructural.ProductCategories',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Structural + MENU_NAME_SUFFIX,
};
